"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "BaseViewStrategy", {
    enumerable: true,
    get: function() {
        return BaseViewStrategy;
    }
});
const _common = require("@nestjs/common");
const _passport = require("@nestjs/passport");
const _passportcustom = require("passport-custom");
const _nocodbsdk = require("nocodb-sdk");
const _models = require("~/models");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
let BaseViewStrategy = class BaseViewStrategy extends (0, _passport.PassportStrategy)(_passportcustom.Strategy, 'base-view') {
    // eslint-disable-next-line @typescript-eslint/ban-types
    async validate(req, callback) {
        try {
            let user;
            if (req.headers['xc-shared-base-id']) {
                const sharedBase = await _models.Base.getByUuid(req.context, req.headers['xc-shared-base-id']);
                // block shared base for private base
                if (sharedBase.default_role) {
                    return callback(new _common.UnauthorizedException('Shared base feature is not available for private bases. Please contact the base owner for access.'));
                }
                // validate base id
                if (!sharedBase || req.ncBaseId !== sharedBase.id) {
                    return callback(new _common.UnauthorizedException());
                }
                user = {
                    roles: (0, _nocodbsdk.extractRolesObj)(sharedBase == null ? void 0 : sharedBase.roles),
                    base_roles: (0, _nocodbsdk.extractRolesObj)(sharedBase == null ? void 0 : sharedBase.roles)
                };
            }
            callback(null, user);
        } catch (error) {
            callback(error);
        }
    }
};
BaseViewStrategy = _ts_decorate([
    (0, _common.Injectable)()
], BaseViewStrategy);
